// extracted by mini-css-extract-plugin
module.exports = {"footer":"TransactionModal_footer__2n-Go"};